const required = (value: string | undefined) => (value ? undefined : true);

const notFirstAndLastName = (value: string | undefined) => {
    if (value === undefined) {
        return true;
    }

    let [fname, lname] = value.split(' ');
    if (!fname || !lname) {
        return true;
    }

    return undefined;
};
const email = (value: string | undefined) => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? true : undefined);

const phoneNumber = (value: string | undefined) => (value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? true : undefined);

const website = (value: string | undefined) =>
    value && !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(value)
        ? true
        : undefined;

export { required, email, phoneNumber, website, notFirstAndLastName };
